import type { SVGProps } from "react";

export const AppleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={21}
    fill="none"
    {...props}
  >
    <path
      fill="#FAFAFA"
      d="M8.447 4.812c1.186.098 2.373-.593 3.115-1.469.729-.9 1.21-2.11 1.087-3.343-1.05.05-2.348.69-3.09 1.592-.68.777-1.26 2.035-1.112 3.22M8.632 6.02c.816 0 2.287-1.073 4.005-.974.667.05 2.595.247 3.831 2.073-.098.074-2.286 1.332-2.261 3.972.024 3.159 2.768 4.207 2.793 4.232-.025.074-.433 1.493-1.434 2.948-.877 1.284-1.78 2.542-3.213 2.567-1.385.024-1.842-.827-3.436-.827-1.582 0-2.102.802-3.412.851-1.384.05-2.435-1.357-3.312-2.64C.4 15.632-.971 10.918.883 7.735c.902-1.591 2.546-2.59 4.313-2.615 1.36-.025 2.608.9 3.436.9"
    />
  </svg>
);
